import React, { useEffect } from 'react';

const About = () => {
  useEffect(() => {
    const revealOnScroll = () => {
      const elements = document.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 100;
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('visible');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  return (
    <section className="about" id="about">
      <div className="about-content">
        <h2 className="fade-in">Meet The Developers</h2>
        <p className="about-text fade-in">
          Raix is crafted by a dedicated team of developers who understand what Discord communities need. 
          Our mission is to provide a comprehensive, reliable, and easy-to-use bot that enhances every server it joins.
        </p>
        <div className="developers">
          <div className="developer slide-in-left">
            <div className="developer-photo">
              <img src="https://i.postimg.cc/1tqQfL80/1760941334088.jpg" alt="RaiMohan" />
            </div>
            <h4>RaiMohan</h4>
            <p>Lead Developer</p>
          </div>
          <div className="developer slide-in-right">
            <div className="developer-photo">
              <img src="https://i.postimg.cc/vZVL2hxk/9bd59c6fd22952b35122e5957cb45177.jpg" alt="RaiSunny" />
            </div>
            <h4>RaiSunny</h4>
            <p>Co-Developer</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
